import type * as Types from '@shared/types/graphqlGenerated.ts';

import * as Operations from './EnableMFA.mutation';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EnableMfaSharedMutationVariables = Types.Exact<{
  input: Types.AuthUserTwoFactorAuthenticationEnableInput;
}>;


export type EnableMfaSharedMutation = { auth?: Types.Maybe<{ userEnableTwoFactorAuthentication?: Types.Maybe<(
      Pick<Types.AuthUserTwoFactorAuthenticationEnablePayload, 'clientMutationId' | 'newBackupCode' | 'redirectPath'>
      & { twoFactorAuthentication?: Types.Maybe<Pick<Types.TwoFactorAuthentication, 'id' | 'isEnabled'>>, errors: Pick<Types.AuthUserTwoFactorAuthenticationEnableError, 'message'> }
    )> }> };


export type EnableMfaSharedMutationMutationFn = Apollo.MutationFunction<EnableMfaSharedMutation, EnableMfaSharedMutationVariables>;

/**
 * __useEnableMfaSharedMutation__
 *
 * To run a mutation, you first call `useEnableMfaSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMfaSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMfaSharedMutation, { data, loading, error }] = useEnableMfaSharedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableMfaSharedMutation(baseOptions?: Apollo.MutationHookOptions<EnableMfaSharedMutation, EnableMfaSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableMfaSharedMutation, EnableMfaSharedMutationVariables>(Operations.EnableMFA_Shared_Mutation, options);
      }
export type EnableMfaSharedMutationHookResult = ReturnType<typeof useEnableMfaSharedMutation>;
export type EnableMfaSharedMutationMutationOptions = Apollo.BaseMutationOptions<EnableMfaSharedMutation, EnableMfaSharedMutationVariables>;